// extracted by mini-css-extract-plugin
export default {"button":"s_button__TkzG3","error":"s_error__tzxET","spinnerWrap":"s_spinnerWrap__6hQNR","spinner":"s_spinner__Vr6Nz"};